import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import BookingPage from "@/pages/BookingPage";
import IntakeForm from "@/pages/IntakeForm";
import { initTracking } from "@/lib/tracking";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("3sm_token"));
  const [checking, setChecking] = useState(true);

  const login = async (email, password) => {
    const { data } = await axios.post(`${BACKEND_URL}/api/auth/login`, { email, password });
    localStorage.setItem("3sm_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("3sm_token");
    setToken(null);
    setUser(null);
  };

  useEffect(() => {
    initTracking();
    if (token) {
      axios.get(`${BACKEND_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(({ data }) => setUser(data))
        .catch(() => { logout(); })
        .finally(() => setChecking(false));
    } else {
      setChecking(false);
    }
  }, []);

  if (checking) return null;

  return (
    <AuthContext.Provider value={{ user, token, login, logout, BACKEND_URL }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/apply" element={<IntakeForm />} />
          <Route path="/admin/login" element={!user ? <AdminLogin /> : <Navigate to="/admin" />} />
          <Route path="/admin" element={user ? <AdminDashboard /> : <Navigate to="/admin/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
